// extracted by mini-css-extract-plugin
export var divider = "_2n-0";
export var dividerText = "_2n-1";